import { AbstractPmsApiService } from './abstract.service';
import { Property } from '../models/property.model';

export class AccountCancellationPmsApiService extends AbstractPmsApiService {

    get urlPattern() {

        return '/billing/property-cancellation(/:id)';
    }

    newModel(attributes, ...params) {

        return new Property(attributes);
    }

    getCanCancelled(params = {}) {

        const url = this.url();

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param model
     * @param property
     * @return {*}
     */
    submit(model, property) {

        const url = this.url({
            id: property.id,
        });

        return this.http
            .post(url, model, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/account-cancellation.service.js